<template>
    <div
        data-value="on"
        class="switchButton"
        v-bind:class="customizedStyle"
    >
        <input
            v-bind:id="name"
            type="checkbox"
            v-bind:checked="value"
            v-bind:disabled="isDisabled"
        >
        <label v-bind:for="name" v-on:click="emit('toggle', !value)">
            <slot name="buttonWithTitle" />
        </label>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent } from 'vue';

    export default defineComponent({
        name: 'SwitchButton',
        props: {
            name: {
                type: String,
                default: 'text',
            },
            value: {
                type: Boolean,
                default: false,
            },
            isDisabled: {
                type: Boolean,
                default: false,
            },
            isWithTitle: {
                type: Boolean,
                default: false,
            },
            mode: {
                type: String,
                default: 'light',
            },
            size: {
                type: String,
                default: 'md',
            },
        },
        setup(props, { emit }) {
            const customizedStyle = computed(() => {
                const classlist: string[] = [props.mode, props.size];
                if (props.isDisabled) classlist.push('isDisabled');
                if (props.isWithTitle) classlist.push('withTitle');
                if (props.value) classlist.push('_active');
                return classlist;
            });
            return {
                emit,

                customizedStyle,
            };
        },
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/common/switchButton";
</style>
